import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { IUploadFile } from '../../../../store/models/general-models';
import { InlineSpinner, LazyImage,SVG } from '../../../../components';
import { DndDeleteButton, DndFileWrapper, Loader } from './file.styled';
import { ReactComponent as trash } from '../../../../assets/icons/trash.svg';

interface IProps {
  file: IUploadFile;
  inProccess: boolean;
  readOnly: boolean;
  onDeleteFile: (file: IUploadFile) => void;
}

export const DndFile: FC<IProps> = observer(
  ({ file, inProccess, readOnly, onDeleteFile }) => {
    const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onDeleteFile(file);
    };

    return (
      <DndFileWrapper>
        {inProccess && (
          <Loader>
            <InlineSpinner />
          </Loader>
        )}
        {!readOnly && !!file.file && (
          <DndDeleteButton
            size={'xs'}
            mode={'neutral'}
            variant={'minor'}
            onClick={handleDelete}
            disabled={file.isPending}
          >
            <SVG
              src={trash}
              props={{
                color: 'currentColor',
                cursor: 'inherit',
              }}
            />
          </DndDeleteButton>
        )}
        {!!file.thumbnailSrc && <LazyImage photo={file} />}
      </DndFileWrapper>
    );
  }
);
